import { observer } from "mobx-react-lite";
import ErrorIcon from "../icons/ErrorIcon.jsx";


const Error = observer(({ children, visible }) => {
    return <div className="error" style={{ display: visible ? 'flex' : 'none' }}>
        <ErrorIcon />
        <span>{children}</span>
    </div>
})
Error.displayName = 'Error'
export default Error